export const TOTAL_BLUES_AMOUNT = 100_000_000;
